<template>
  <header>
    <div
      class="bg-[#161616] w-[100vw] flex flex-row justify-center items-center fixed h-[73px] z-10 ios-safe-area-top"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    >
      <div
        class="w-[100vw] max-w-[856px] flex flex-row justify-between items-center px-6 lg:px-0"
      >
        <!-- <router-link to="/"> -->
        <div class="my-[20px] inline-flex items-center">
          <div>
            <img
              src="../../../public/assets/images/gic-conf-logo.svg"
              class="w-full h-full"
              alt="gic conf logo"
            />
          </div>
        </div>
        <!-- </router-link> -->
        <div class="hidden md:flex flex-row gap-[48px]">
          <div
            class="flex h-[24px] items-center gap-[8px] self-center text-[#FFFFFF] text-[16px] font-[400] leading-[20px] cursor-pointer header-resources"
            :class="{
              'underline font-bold': $route.path === '/resources/sessions',
            }"
            data-event-tracking="header-resources"
            data-test-id="header-resources"
            @click="navigateTo('/resources/sessions')"
          >
            Resources
          </div>

          <div
            class="flex h-[24px] items-center gap-[8px] self-center text-[#FFFFFF] text-[16px] font-[400] leading-[20px] cursor-pointer header-photos"
            data-event-tracking="header-photos"
            data-test-id="header-photos"
            @click="goToPhotos()"
          >
            Photos
          </div>

          <div
            class="flex h-[24px] items-center gap-[8px] self-center text-[#FFFFFF] text-[16px] font-[400] leading-[20px] cursor-pointer header-whatsnext"
            :class="{ 'underline font-bold': $route.path === '/whats-next' }"
            data-event-tracking="header-whats-next"
            data-test-id="header-whats-next"
            @click="navigateTo('/whats-next')"
          >
            What's Next
          </div>

          <div
            class="flex h-[24px] items-center gap-[8px] self-center text-[#FFFFFF] text-[16px] font-[400] leading-[20px] cursor-pointer header-logout"
            data-event-tracking="gic-home-logout"
            data-test-id="gic-home-logout"
            @click="openModal()"
          >
            <img
              src="../../../public/assets/icons/log-out-white.svg"
              class="w-[24px] h-[24px]"
            />
            <p>Log Out</p>
          </div>
        </div>
        <div class="block md:hidden" @click="toggleMenu">
          <img
            src="../../../public/assets/icons/menu-icon.svg"
            class="w-[40px] h-[40px]"
            alt="menu"
          />
        </div>
      </div>
    </div>
    <MobileMenu
      :isOpen="isMenuOpen"
      @close-menu="toggleMenu"
      @open-logout-modal="openLogoutModal"
    />
  </header>
</template>

<script>
import MobileMenu from "@/components/common/MobileMenu.vue";
export default {
  name: "CommonHeader",
  components: {
    MobileMenu,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    openModal() {
      this.isDropdownVisible = false;
      this.$emit("open-modal");
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    navigateTo(route) {
      this.$router.push(route);
    },
    openLogoutModal() {
      this.isMenuOpen = false;
      this.$emit("open-modal");
    },
    goToPhotos() {
      window.open(
        "https://hogcphotographyministry.pixieset.com/generationsimplementationcommunity2/",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.ios-safe-area-top {
  padding-top: env(safe-area-inset-top);
  height: calc(73px + env(safe-area-inset-top));
}
</style>
